import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { FunctionComponent, useEffect, useState } from 'react';

export interface DiscountTypeButtonProps {
    icon: IconDefinition;
    selected: boolean;
    onSelected?: () => void;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: 54,
            height: 54,
            borderRadius: 6,
            backgroundColor: '#F1F1F1',
            border: '1px solid #F1F1F1',
            cursor: 'pointer'
        },
        selected: {
            backgroundColor: '#000',
            border: '1px solid #000'
        }
    })
);

export const DiscountTypeButton: FunctionComponent<DiscountTypeButtonProps> = props => {
    const classes = useStyles(props);

    const [selected, setSelected] = useState(props.selected);

    useEffect(() => {
        props.selected !== selected && setSelected(props.selected);
    }, [props.selected]);

    const clickHandler = () => {
        if (!selected) {
            const prevSelected = selected;
            setSelected(prev => !prev);
            props.onSelected && props.onSelected();
        }
    };

    return (
        <Box
            className={clsx(classes.container, { [classes.selected]: selected }, props.className)}
            onClick={clickHandler}
        >
            <FontAwesomeIcon
                icon={props.icon}
                fontSize={20}
                color={selected ? '#FFF' : '#7A7A7A'}
            />
        </Box>
    );
};

export default DiscountTypeButton;
